import React, { Component } from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'

import { pushHistoryWithSupportSection } from '../../../../utils/routing';
import { formatDateTime } from '../../../../utils/formatting';

import Tag from '../../../Tag/Tag';
import { ActionDeleted } from '../../../ActionDeleted/ActionDeleted';
import { ActionEdited } from '../../../ActionEdited/ActionEdited';
import { ActionHidden } from '../../../ActionHidden/ActionHidden';
import { ActionShow } from '../../../ActionShow/ActionShow';

import styles from './Ticket.module.css'

export default class Ticket extends Component {
    static propTypes = {
        ticketId: PropTypes.number, // this id of ticket (many sms = question and answers)
        id: PropTypes.number, // this id of main sms (question)
        modData: PropTypes.shape({
            modId: PropTypes.number,
            modVersionId: PropTypes.number,
            modVersion: PropTypes.string,
        }),
        problemTypes: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            title: PropTypes.string,
        })), // array in string with support-tags
        createdAt: PropTypes.string,
            updatedAt: PropTypes.string, // time of last answer for this question
        readUser: PropTypes.bool, // read OR not read user'om
        readAgent: PropTypes.bool, // read OR not read agent'om
        role: PropTypes.string, // role of sms owner - user, moderator, admin, robot, modCreator
        isAgent: PropTypes.bool,
        ownerId: PropTypes.number,
            ownerName: PropTypes.string,
        isClose: PropTypes.bool,
        content: PropTypes.string,
        lang: PropTypes.string,
        fileOriginalName: PropTypes.string, // if this sms has download image
        fileSize: PropTypes.number, // if this sms has download image

        isOpened: PropTypes.bool,

        tagReport: PropTypes.bool,

        onClickDeleteTicket: PropTypes.func.isRequired,
    }

    sliceText = (text, slicer = 100) => { // 140  62
        let sliced = text;
        if (text) {
            if (text.length > slicer) {
                sliced = text.slice(0, slicer)+'...';
            }
        }

        return sliced;
    }

    handleClickTicket = () => {
        pushHistoryWithSupportSection(this.props.history, this.props.ticketId)
    }

    handleClickShowOrHidden = () => {
        this.props.onClickShowOrHiddenTicket(this.props.ticketId, this.props.isClose)
    }

    handleClickFastAnswerTicket = () => {
        this.props.onClickFastAnswerTicket(this.props.ticketId)
    }

    handleClickDeleteTicket = () => {
        this.props.onClickDeleteTicket(this.props.ticketId)
    }

    renderButtonShowOrHidden() {
        return this.props.isClose ? (
            <span className={styles.ticketButtons__btn} title="Открыть тикет">
                <ActionShow onClick={this.handleClickShowOrHidden} />
            </span>
        ) : (
            <span className={styles.ticketButtons__btn} title="Закрыть тикет">
                <ActionHidden onClick={this.handleClickShowOrHidden} />
            </span>
        )
    }
    
    renderButtonFastAnswer() {
        return !this.props.isClose ? (
            <span className={styles.ticketButtons__btn} title="Быстрый ответ">
                <ActionEdited onClick={this.handleClickFastAnswerTicket} />
            </span>
        ) : null
    }

    renderButtonDeleteTicket() {
        return (
            <span className={styles.ticketButtons__btn} title="Удалить тикет">
                <ActionDeleted onClick={this.handleClickDeleteTicket} />
            </span>
        )
    }

    renderButtons() {
        return (
            <div className={styles.ticketButtons}>
                {this.renderButtonFastAnswer()}
                {this.renderButtonShowOrHidden()}
                {this.renderButtonDeleteTicket()}
            </div>
        )
    }

    renderTags() {
        const isDisabled = false//this.state.isCheckedAll && !this.state.problemIds.includes(item.id)

        const type = !this.props.tagReport ? 'yellow' : 'warning' // 'light', 'lesta', 'blue', 'warning', 'yellow'

        return this.props.problemTypes.map((item, index) => {
            //const isDisabled = this.state.isCheckedAll && !this.state.problemIds.includes(item.id)
            return (
                <div className={styles.tag} key={`problem-tag-${item.id}-${index}`}>
                    <Tag
                        caption={item.title}
                        id={item.id}
                        //isChecked={this.state.problemIds.includes(item.id)}
                        isDisabled={isDisabled}
                        isError={false}//{this.state.isErrorProblemType}
                        type={type}

                        //isSupport={false}

                        onClick={() => {}}
                    />
                </div>
            )
        })
    }

    renderClosedBlock() {
        return this.props.isClose ? (
            <div className={classNames(styles["conversation-post-content_title"], styles["conversation-post-content_title__main"])}>
                <span data-msgid="Closed" data-current-language="ru">Закрыт</span>
            </div>
        ) : null
    }

    renderModInfo() {
        return this.props.tagReport === true ? 
            typeof this.props.modData !== 'undefined' ? (
                <>
                <div>
                    <span className={styles.ticketFooter__contentId}>Мод ID :</span>
                    <span style={{marginRight: '.75rem'}}>{this.props.modData.modId}</span>
                </div>
                <div>
                    <span className={styles.ticketFooter__contentId}>Версия мода :</span>
                    <span style={{marginRight: '.75rem'}}>{this.props.modData.modVersion}</span>
                </div>
                </>
            ) : null
        : null
    }

    renderTicketIcon() {
        return this.props.readAgent ? (
            <div className={styles.ticketIcon__open}></div>
        ) : (
            <div className={styles.ticketIcon__close}></div>
        )
        /*
        return (
            <svg className={styles.ticketIcon__content} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="currentColor">
                <path fill="currentColor" d="M10.335 1.348a.625.625 0 0 0-.67 0L3.657 5.17A2.5 2.5 0 0 0 2.5 7.28v6.47a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5V7.28a2.5 2.5 0 0 0-1.158-2.11l-6.006-3.822ZM4.33 6.225 10 2.615l5.671 3.61c.332.21.543.565.575.953L10 10.54 3.754 7.175a1.25 1.25 0 0 1 .575-.95ZM3.75 8.592 9.703 11.8c.185.1.408.1.593 0l5.954-3.205v5.155c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25V8.592Z"></path>
            </svg>
        )
        */
    }

    render() {
        const ticketWrapperStyle = classNames(styles.ticketWrapper, [{
            //[styles.isOpened]: this.props.isOpened,
        }])
        
        return (
            <div className={ticketWrapperStyle} st="support-ticket-element">
                {this.renderClosedBlock()}
                <div className={styles.ticketBody} onClick={() => this.handleClickTicket()}>
                    <div className={styles.ticketIcon} title="Прочитан" style={{width: '20px',height: '20px'}}>
                        {this.renderTicketIcon()}
                    </div>
                    <div className={styles.ticketContent}>
                        <div className={styles.tags}>
                            {this.renderTags()}
                        </div>
                        <span className={classNames(styles.ticketContent__text)} title={this.props.ownerId} style={{color: "var(--all-text-color)",}}>
                            Автор: {this.props.ownerName}
                        </span>
                        <span className={classNames(styles.ticketContent__text, styles['hover:ticketContent__text-hover'])} title={this.props.content} st="support-ticket-link">
                            {this.sliceText(`${this.props.content}`)}
                        </span>
                        {/* <a className={classNames(styles.ticketContent__text, styles['hover:ticketContent__text-hover'])} href="/admin-panel/support/2579640" title="Изменение данных администратора tankimods.net" st="support-ticket-link">
                            {this.sliceText('Возможность нахождения поисковых ключей в тексте и определения их количества полезна как для написания нового текста, так и для оптимизации уже существующего. Расположение ключевых слов по группам и по частоте сделает навигацию по ключам удобной и быстрой. Сервис также найдет и морфологические варианты ключей, которые выделятся в тексте при нажатии на нужное ключевое слово.')}
                        </a> */}
                    </div>
                </div>
                <div className={styles.ticketFooter} st="support-ticket-list-time" onClick={() => this.handleClickTicket()}>
                    <div title={this.props.ticketId}>
                        <span className={styles.ticketFooter__contentId}>Тикет ID :</span>
                        <span style={{marginRight: '.75rem'}}>{this.props.ticketId}</span>
                    </div>
                    {this.renderModInfo()}
                    <div className={styles.ticketFooter__contentTime}>
                        <div className={styles.ticketFooter__contentTime_text}>Последнее сообщение :</div>
                        <div style={{whiteSpace: 'nowrap'}}>{formatDateTime(this.props.updatedAt)}</div>
                    </div>
                </div>
                {this.renderButtons(this.props.ticketId)}
            </div>
        )
    }
}
